// extracted by mini-css-extract-plugin
export default {"loginPanel":"Login_loginPanel__O+GFw","Clock":"Login_Clock__DiAmf","Heading":"Login_Heading__OefFa","Header":"Login_Header__aGQxR"};